import React, {PureComponent} from "react"
import {isEmpty} from "lodash"

import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import {injectIntl, InjectIntl} from "@irati/utils/lang"

interface Props extends InjectIntl {
  value: string,
  onChange?: (value: string) => void,
  onBlur?: (value: string) => void,
  validation?: () => any
}

class ExternalID extends PureComponent<Props> {
  buildExternalIDSchema = () => {
    return Validation.string()
      .test(
        "notJustSpaces",
        "platform.fields.externalID.schema.notJustSpaces",
        (value: string) => !isEmpty(value) ? value.trim().length !== 0 : true
      )
  }

  render() {
    const {validation, formatMessage, ...props} = this.props

    return (
      <Input
        name="externalID"
        label={formatMessage({id: "platform.fields.externalID.label"})}
        {...props}
        validation={validation || this.buildExternalIDSchema()} />
    )
  }
}

export default injectIntl(ExternalID)
